import React, { useState } from "react";
import TableDisplay from "./TableDisplay";
import * as Yup from "yup";

export default function AutoMessage() {
  const title = ["id", "meassage", "status"];
  const formConfig = {
    fields: [
      {
        name: "meassage",
        label: "Message",
        type: "textarea",
      },
      {
        name: "status",
        label: "Status",
        type: "switch",
      },
    ],
    validationSchema: Yup.object({
      meassage: Yup.string().required("message Required"),
    }),
  };

  const initialValues = {
    meassage: "",
    status: 0,
  };
  return (
    <div>
      <TableDisplay
        category="Auto Message"
        tableurl="admin-get-auto-message"
        title={title}
        deleteurl="admin-delete-auto-message"
        deleteallurl="admin-all-delete-auto-message"
        addurl="admin-add-auto-message"
        formConfig={formConfig}
        initialValues={initialValues}
        updateurl="get-edit-auto-message"
        updatteurl="admin-edit-auto-message"
        serachCategory=""
        statusurl="admin-status-auto-message"
        axiosHeader={false}
      />
    </div>
  );
}
